


export default function Technology() {

    return(

        <>
        <h2>this is Technology</h2>
        </>
    )
}